export default {
    BACK: "Вернуться"
};
